import React from 'react'
import { Avatar, Grid } from '@mui/material'
import { ChatElement } from './ChatArea'
import { Message } from './Message'
import './Bubble.css'
import { useSkin } from '@hooks/useSkin'

interface BubbleTextProps {
  text: string,
  avatar: string
}

const BubbleSendText = ({ text, avatar }: BubbleTextProps) => {
  const { skin } = useSkin()

  return (
    <Grid container spacing={3} alignItems='flex-end'>
      <Grid item xs={11}>
        <div className={"mine messages"}>
          <div className={`message last ${skin === 'dark' ? 'dark' : ''}`}>{text.replace("\n", "<br />")}</div>
        </div>
      </Grid>
      <Grid item xs={1}>
        <Avatar alt='me' sx={{ width: 30, height: 30 }} src={avatar} />
      </Grid>
    </Grid>
  )
}

const BubbleReceiveText = ({ text, avatar }: BubbleTextProps) => {
  const { skin } = useSkin()

  return (
    <Grid container spacing={3} alignItems='flex-end'>
      <Grid item xs={1}>
        <Avatar alt='Optimus' sx={{ width: 30, height: 30 }} src={avatar} />
      </Grid>
      <Grid item xs={11}>
        <div className={`yours messages`}>
          <div className={`message last ${skin === 'dark' ? 'dark' : ''}`}>{text}</div>
        </div>
      </Grid>
    </Grid>
  )
}

function bubbleText(message: Message, avatar: string) {
  const element: ChatElement = {
    content:
      message.from === 'me' ? (
        <BubbleSendText key={message.id} text={message.text} avatar={avatar} />
      ) : (
        <BubbleReceiveText key={message.id} text={message.text} avatar={avatar} />
      ),
    position: message.from === 'me' ? 'right' : 'left'
  }

  return element
}

function computingBubble(avatar: string) {
  const computing: ChatElement = {
    content: <BubbleReceiveText key={'computing'} text={`Je réfléchis...`} avatar={avatar} />,
    position: 'left'
  }

  return computing
}

export { bubbleText, computingBubble }
